import {connect} from "react-redux"
import {createSelector} from "reselect"
import {setFacetsModal} from "../../ducks/viewAllModal"
import State from "../../models/State"

// Selectors
const selectViewAllModalFacets = (state: State) => state.viewAllModal.facets
const selectViewAllModalDisplayName = (state: State) => state.viewAllModal.displayName
const selectText = (state: State) => state.text
const selectSearchFilters = (state: State) => state.search.filters

const makeSelectSearchFacets = createSelector([selectViewAllModalFacets], facets =>
    Object.keys(facets).map((key: string) => ({
        n: facets[key].n,
        v: key,
    })),
)

const makeSelectDisplayName = createSelector([selectViewAllModalDisplayName], displayName => displayName?.toLowerCase())

export const mapStateToProps = (state: State) => ({
    facets: selectViewAllModalFacets(state),
    searchFacets: makeSelectSearchFacets(state),
    displayName: makeSelectDisplayName(state),
    text: selectText(state),
    filters: selectSearchFilters(state),
})

export const mapDispatchToProps = dispatch => ({
    handleSetFacetModal: (facetValue: string): void => {
        dispatch(setFacetsModal(facetValue))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
